// styles imports
import './CloseButton.scss';

/**
 * モーダル右上などの閉じる(×)ボタン。見た目は全モーダルで共通にする
 *
 * [set]
 * 		className	... 追加のクラス(配置の調整用)
 * 		title		... ツールチップ(既定は「閉じる」)
 * 		disabled	... 押せなくする
 * [act]
 * 		onClick		... 押下時の処理
 */
export default function CloseButton(props) {
	return (
		<button
			type="button"
			className={"close-icon-button " + (props.className ? props.className : "")}
			title={props.title ? props.title : "閉じる"}
			disabled={props.disabled}
			onClick={props.onClick}
		>
			<i className="bi bi-x-lg" />
		</button>
	);
}
